module.exports = __webpack_public_path__ + "media/product/marker-ring@2x-42aeb82f.png";